/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React, { useState, useRef, useEffect } from 'react';
import styles from './Dropdown.module.css';
export default function Dropdown({
    trigger,
    options = [],
    onSelect,
    align = 'left',
    direction = 'down',
    children,
    className = ''
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpen]);
    const handleSelect = (option) => {
        if (option.onClick) {
            option.onClick(option);
        }
        if (onSelect) {
            onSelect(option);
        }
        setIsOpen(false);
    };
    return (
        <div className={`${styles.dropdown} ${className}`} ref={dropdownRef}>
            <div className={styles.trigger} onClick={() => setIsOpen(!isOpen)}>
                {trigger}
            </div>
            {isOpen && (
                <div className={`${styles.menu} ${styles[align]} ${styles[direction]}`}>
                    {children ? children : options.map((option, index) => (
                        <div
                            key={index}
                            className={`${styles.item} ${option.active ? styles.active : ''}`}
                            onClick={() => handleSelect(option)}
                        >
                            {option.icon && <span className={styles.icon}>{option.icon}</span>}
                            <span className={styles.label}>{option.label}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
